/* eslint-disable */
import type {Config} from 'bfu-auth-client/src/login/data/Config.js';

// dont load polyfills, these should be loaded by the app that loads this

import React from 'react';
import ReactDOM from 'react-dom';

import LoginRoot from 'bfu-auth-client/src/login/LoginRoot.jsx';
import {appendCSS} from 'bfu-auth-client/src/css/css.js';

import {DefaultConfig} from 'bfu-auth-client/src/login/data/Config.js';
import mergeDeep from 'unmutable/mergeDeep';

window["reactMicromounts"] = window["reactMicromounts"] || [];
window["reactMicromounts"].push({
    mount: (container, props) => {
        const config: Config = mergeDeep(props.config || {})(DefaultConfig);
        appendCSS(config);
        ReactDOM.render(<LoginRoot config={config} />, container);
    },
    unmount: (container) => {
        ReactDOM.unmountComponentAtNode(container);
    }
});
